import { css, Global, Theme } from '@emotion/react';
import '@fontsource/baskervville';
import '@fontsource/montserrat';
import '@fontsource/montserrat/500.css';
import emotionNormalize from 'emotion-normalize';
import { h1, h2, h3, h4 } from './Typography';

export const theme: Theme = {
    colors: {
        black: '#000000',
        dark: '#181818',
        light: '#F4F4F4',
        white: '#FFFFFF',
        accent: '#E3C071',
        gradient: 'radial-gradient(81.25% 101.74% at 92.59% 24.07%, #E3C071 0%, #B08421 100%)',
    },
    spacing: {
        md: '2.22vw', //32px at 1440px wide viewport
        lg: '4.45vw', //64px ^^
        xl: '6.67vw', //96px ^^
        xxl: '8.89vw', //128px ^^
    },
};

export const GlobalStyles = () => {
    return (
        <Global
            styles={() => css`
                ${emotionNormalize};

                html {
                    font-size: 100%;
                    scroll-behavior: smooth;
                }
                body {
                    color: ${theme.colors.dark};
                    font-family: 'Montserrat', sans-serif;
                    font-weight: normal;
                    font-size: 1rem;
                    line-height: 212.5%;
                    word-wrap: break-word;
                    font-kerning: normal;
                    word-wrap: break-word;
                    -webkit-font-smoothing: antialiased;
                    overflow-x: hidden;
                    top: 0 !important;
                }

                h1 {
                    ${h1};
                }

                h2 {
                    ${h2};
                }

                h3 {
                    ${h3};
                }

                h4 {
                    ${h4};
                }

                a {
                    text-decoration: none;
                    color: ${theme.colors.dark};
                    outline: none;
                    background-color: transparent;
                    -webkit-text-decoration-skip: objects;
                }

                *,
                *:before,
                *:after {
                    box-sizing: border-box;
                }

                svg,
                img {
                    max-width: 100%;
                    display: block;
                    margin: 0;
                    padding: 0;
                }

                ul,
                ol {
                    padding-inline-start: 24px;
                }

                .skiptranslate {
                    display: none;
                }

                [data-reach-skip-nav-link]:focus {
                    z-index: 111;
                }

                // for animations on homepage

                .reveal {
                    transform: translateY(70px);
                    opacity: 0;
                    transition:
                        transform 0.5s ease-in-out,
                        opacity 0.5s ease-in-out;
                }

                .reveal-left {
                    transform: translateX(-70px);
                    opacity: 0;
                    transition:
                        transform 0.5s ease-in-out,
                        opacity 0.5s ease-in-out;
                }

                .reveal-right {
                    transform: translateX(70px);
                    opacity: 0;
                    transition:
                        transform 0.5s ease-in-out,
                        opacity 0.5s ease-in-out;
                }

                .revealed {
                    opacity: 1;
                    transform: translate(0);
                }

                .reveal-delay-1 {
                    transition-delay: 0.1s;
                }

                .reveal-delay-2 {
                    transition-delay: 0.2s;
                }

                .reveal-delay-3 {
                    transition-delay: 0.3s;
                }

                .reveal-delay-4 {
                    transition-delay: 0.37s;
                }

                .reveal-delay-5 {
                    transition-delay: 0.44s;
                }

                .reveal-delay-6 {
                    transition-delay: 0.5s;
                }

                .reveal-delay-7 {
                    transition-delay: 0.54s !important;
                }

                .reveal-delay-8 {
                    transition-delay: 0.57s !important;
                }

                .reveal-delay-9 {
                    transition-delay: 0.6s !important;
                }
            `}
        />
    );
};
